import * as React from "react";
import "./backButton.css";
import arrowLineLeft1x from "../../icons/atoms/arrowLineLeft/arrow_line_left.png";
import arrowLineLeft2x from "../../icons/atoms/arrowLineLeft/arrow_line_left@2x.png";
import arrowLineLeft3x from "../../icons/atoms/arrowLineLeft/arrow_line_left@3x.png";

class BackButton extends React.Component<any, any> {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div className="BACK_BUTTON_CONT">
        <img
          src={arrowLineLeft1x}
          srcSet={`${arrowLineLeft1x} 1x, ${arrowLineLeft2x} 2x, ${arrowLineLeft3x} 3x`}
        />
      </div>
    );
  }
}

export default BackButton;



// WEBPACK FOOTER //
// ./src/components/backButton/backButton.tsx